import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicPlaylistWithRecordings } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getPlaylist = async (
  organisationId: string,
  id: string,
): Promise<PublicPlaylistWithRecordings> => {
  const response = await axiosClient.get(`${organisationId}/playlists/${id}`);
  return response.data;
};

export function playlistQueryKey(orgId: string, id: string) {
  return ["playlists", orgId, id];
}

export function useGetPlaylist(
  {
    organisationId,
    id,
  }: {
    organisationId: string;
    id: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<PublicPlaylistWithRecordings, HttpError>
  >,
) {
  return useQuery({
    queryKey: playlistQueryKey(organisationId, id),
    queryFn: () => getPlaylist(organisationId, id),
    ...queryOptions,
  });
}
